import { IconButton } from "@mui/material";
import classNames from "classnames";
import { ExternalLinkIkon } from "../../../../../../shared/icons/ExternalLinkIcon";
import styles from "../styles.module.css";

interface Props {
  handleTransferPublishVersion: () => void;
  isDisabled: boolean;
}

export const LinkTransferController = ({
  handleTransferPublishVersion,
  isDisabled,
}: Props) => {
  return (
    <IconButton
      className={styles["action-button"]}
      onClick={handleTransferPublishVersion}
      disabled={isDisabled}
    >
      <ExternalLinkIkon
        className={classNames({
          [styles["disabled"]]: isDisabled,
        })}
      />
    </IconButton>
  );
};
